<script>
import baseList from "@/views/components/base/baseList.vue";
import config from "@/../config";

export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "sysTasks",
        key: "id",
        url: {
          list: `/admin/system/task/list`,
          del: `/admin/system/task/del`,
        },
        output: false,
      },
      menus: [
        {
          label: "任务列表",
          name: "sysTask_info",
          auth: "system/sysTask/index",
        },
        {
          label: "我的任务",
          name: "sysTask_my",
          auth: "system/sysTask/myindex",
        },
      ],
      actions: [
        {
          label: "新增任务",
          icon: "md-add",
          onClick: this.toAdd,
          auth: "",
          type: "info",
        },
      ],
      filters: [
        {
          label: "发起人",
          name: "applyUser",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "任务内容",
          name: "applyContent",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "负责人",
          name: "finishUser",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "处理内容",
          name: "finishContent",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },

        {
          label: "紧急程度",
          name: "emergencyDegree",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [
            {
              value: 1,
              name: "一般",
            },
            {
              value: 2,
              name: "较重",
            },
            {
              value: 3,
              name: "重要",
            },
            {
              value: 4,
              name: "特别重要",
            },
          ],
        },
        {
          label: "状态",
          name: "state",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [
            {
              value: 1,
              name: "未完成",
            },
            {
              value: 2,
              name: "已完成",
            },
          ],
        },
      ],
      tableCols: [
        {
          type: "index",
          title: "序号",
          width: 70,
          align: "center",
        },
        {
          title: "任务内容",
          key: "applyContent",
          minWidth: 300,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.applyContent;
            let tempDescr;
            let teColor;
            if (text != null) {
              if (text.indexOf("]") != -1) {
                let arr = text.split("]");
                let tempDate = parseInt(arr[0]);
                let tempContext = text.replace(arr[0] + "]", "");

                let tempH = Math.floor(tempDate / 60);
                let day = Math.floor(tempH / 24);
                let hour = tempH % 24
                let min = tempDate % 60;
                tempDescr = "[" + day + "天" + hour + "时" + min + "分]" + tempContext;
                if (row.state == 1) {
                  teColor = "red";
                }
              } else {
                tempDescr = "[" + 0 + "天"+ 0 + "时" + 0 + "分]" + text;
              }
            }
            return h("div", [
              h(
                  "span",
                  {
                    style: {
                      display: "inline-block",
                      width: "100%",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      color: teColor,
                    },
                    domProps: {
                      title: tempDescr,
                    },
                  },
                  tempDescr
              ),
            ]);
          },
        },
        {
          title: "责任人",
          key: "finishUser",
          width: 120,
          align: "center",
          // tree: true,
        },
        {
          title: "状态",
          key: "state",
          width: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.state;
            if (text == 1) {
              return <span>未完成</span>;
            } else if (text == 2) {
              return <span>已完成</span>;
            }
          },
        },
        {
          title: "操作",
          align: "center",
          width: 200,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              // let directives = [];
              const row = param.row;

              return (
                  <Button
                      size="small"
                      onClick={() => this.handleEdit(currentRow)}
                      type="default"
                      style={{
                        border: "none",
                        color: "#4991ff",
                        display: row.state === 2 ? "none" : "",
                      }}
                  >
                    编辑
                  </Button>
              );
            },
            (vm, h, currentRow, param) => {
              // let directives = [];
              const row = param.row;
              return (
                  <Button
                      size="small"
                      onClick={() => this.selectChange(currentRow)}
                      type="default"
                      style={{
                        border: "none",
                        color: "#4991ff",
                        margin: "0 10px",
                      }}
                  >
                    详情
                  </Button>
              );
            },
            "delete",
          ],
          auth: {
            edit: "system/sysTask/edit",
          },
        },
      ],
    };
  },
  created() {
  },
  methods: {
    toAdd() {
      $utils.url.push({name: "Edit_Task", query: {action: "add"}});
    },
    handleEdit(row) {
      let kv = row.id;
      $utils.url.push({
        name: "Edit_Task",
        query: {action: "edit", kv: kv},
      });
    },
    selectChange(row) {
      let kv = row.id;
      $utils.url.push({
        name: "Info_Task",
        query: {action: "view", kv: kv},
      });
    },
  },
};
</script>
<style scoped></style>
